<template>
  <div>
    <b-container>
      <h1 class="text-left mt-2 mb-3">Impresszum</h1>
      <div class="bordered-container mt-4">
        <b-row cols="1" class="text-left mb-5">
          <b-col>
            A VALI – a személyre szabott vállalkozói információs portál célja a vállalkozások számára gyors, hiteles és
            személyre szabott információk biztosítása a vállalkozásokat leginkább érdeklő témakörökben.
            <br />
            <br />
            A portál a GINOP-1.1.3-16 kódszámú „Modern Mintaüzem Program I. - Mikro-, kis- és középvállalkozások
            üzletviteli folyamatainak megújítása, valamint a digitális és automatizációs fejlesztések élénkítése” című
            kiemelt projekt keretében valósult meg. A projekt célja a magyarországi konvergencia régiókban működő
            mikro-, kis- és középvállalkozások szervezeti megújulásának és technológiaváltásának elősegítése és
            támogatása, és ezen keresztül a versenyképesség javítása, a vállalkozói környezet és kultúra fejlesztése
            olyan összehangolt beavatkozásokkal, amelyekkel elérhető a piachoz való magas fokú alkalmazkodás.
            <br />
            <br />
            <strong>A honlap üzemeltetője:</strong> <br />Magyar Gazdaságfejlesztési Ügynökség Közhasznú Nonprofit
            Korlátolt Felelősségű Társaság<br /><br />
            <strong>Cégjegyzékszám:</strong> <br />Cg. 01-09-980439 <br /><br />
            <strong>Cím:</strong> <br />1074 Budapest, Rákóczi út 70-72 <br /><br />
            <strong>E-mail: </strong><br />
            <a href="mailto:info@mgfu.hu" class="link">info@mgfu.hu</a>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Impressum'
}
</script>

<style scoped>
.link {
  color: black !important;
}
</style>
